module.exports = __webpack_public_path__ + "static/media/inkscape-logo.9e1bd6bd.svg";